"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'style.form.title.edit': 'Edit Writing Style',
    'style.form.title.add': 'Add Writing Style',
    'style.form.back': 'Back',
    'style.form.name.label': 'Name',
    'style.form.name.placeholder': 'Style name',
    'style.form.description.label': 'Description',
    'style.form.description.placeholder': 'Describe this writing style',
    'style.form.prompt.label': 'Style Prompt',
    'style.form.prompt.placeholder': 'Enter the AI prompt that defines this writing style...',
    'style.form.common.label': 'Common Style',
    'style.form.common.description': 'Common styles are available to all users but can only be edited by super admins',
    'style.form.active.label': 'Active',
};
